export default {
    methods: {
        $captureError(error, context = {}) {
            if (!this.$app?.config?.globalProperties?.$captureError) {
                console.error('Sentry not available:', this.$app);
                return false;
            }

            this.$app.config.globalProperties.$captureError(error, {
                ...context,
                timestamp: new Date().toISOString(),
                component: context.component || 'unknown',
                action: context.action || 'unknown',
            });
            return true;
        },

        $captureMessage(message, level = 'info', context = {}) {
            if (!this.$app?.config?.globalProperties?.$captureMessage) {
                console.error('Sentry not available:', this.$app);
                return false;
            }

            this.$app.config.globalProperties.$captureMessage(message, level, {
                ...context,
                timestamp: new Date().toISOString(),
            });
            return true;
        },
    },
};
